import React, { FC, ReactElement } from 'react';
import { Tabs, Tab } from '@mui/material';
import { GridView, Description, Receipt, AccountBalance, Group } from '@mui/icons-material';
import { Link, useLocation } from 'react-router-dom';

const tabs: { label: string; path: string; icon: ReactElement }[] = [
  {
    label: 'Resumo',
    path: 'summary',
    icon: <GridView />,
  },
  {
    label: 'Pagar',
    path: 'pay',
    icon: <Receipt />,
  },
  {
    label: 'Receber',
    path: 'receive',
    icon: <AccountBalance />,
  },
  {
    label: 'Extrato',
    path: 'balance',
    icon: <Description />,
  },
  // {
  //   label: 'Open Banking',
  //   path: 'open-banking',
  //   icon: <CompareArrows />,
  // },
  {
    label: 'Favorecidos',
    path: 'registration-beneficiaries',
    icon: <Group />,
  },
];

export const TabNavigation: FC = () => {
  const { pathname } = useLocation();

  const activeTab = tabs.findIndex((tab) => pathname.endsWith(tab.path));

  return (
    <Tabs
      value={activeTab === -1 ? 0 : activeTab}
      sx={{
        marginBottom: '32px',
        borderBottom: '1px solid #E0E0E0',
        '& .MuiTab-root': {
          textTransform: 'none',
          fontSize: '14px',
          fontWeight: 500,
          color: '#666',
          minHeight: '64px',
        },
      }}
    >
      {tabs.map(({ label, path, icon }) => (
        <Tab key={path} label={label} icon={icon} iconPosition="start" component={Link} to={path} />
      ))}
    </Tabs>
  );
};
